import React from "react";
import { Link } from "react-router-dom";

const SuccessPage: React.FC = () => {
  return (
    <div className="p-4 text-center">
      <h1 className="text-2xl font-bold mb-4 text-green-500">
        Payment Successful!
      </h1>
      <p className="text-gray-700 mb-4">
        Thank you for your purchase. Your payment was processed successfully.
      </p>
      <Link
        to="/"
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
      >
        Back to Home
      </Link>
    </div>
  );
};

export default SuccessPage;
